export default __webpack_public_path__ + "static/media/DGX-H200-2.01947dd6.png";